import { cva } from "class-variance-authority";

export const rootStyles = cva("flex gap-2", {
  variants: {
    orientation: {
      horizontal: "flex-row",
      vertical: "flex-col",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export const itemStyles = cva(
  [
    "aspect-square rounded-full transition-colors",
    "border border-neutral-80 bg-white",

    "focus:bg-white focus:ring-4 focus:ring-[#F4EBFF] focus:outline-hidden",

    "data-disabled:cursor-not-allowed data-disabled:border-neutral-90 data-disabled:bg-neutral-95",
    "data-disabled:data-[state=checked]:border-neutral-90 data-disabled:data-[state=checked]:bg-neutral-95",

    // animation parts
    "relative",
    "after:content-'' after:absolute after:top-0 after:left-0 after:hidden after:h-full after:w-full",
    "after:rounded-full after:border",
    "data-[state=checked]:after:block data-[state=checked]:after:animate-ping-effect",
  ],
  {
    variants: {
      size: {
        sm: "h-4 w-4",
        md: "h-5 w-5",
      },
      color: {
        primary: [
          "after:border-primary-50 hover:border-primary-50 hover:bg-primary-95 focus:border-primary-80",
          "data-[state=checked]:border-primary-50 data-[state=checked]:bg-primary-95",
        ],
        error: [
          "border-error-50",
          "after:border-error-50 hover:border-error-50 hover:bg-error-95 focus:border-error-80",
          "data-[state=checked]:border-error-50 data-[state=checked]:bg-error-95",
        ],
      },
    },
    defaultVariants: {
      size: "sm",
      color: "primary",
    },
  }
);

// The dot inside the circle, shown once checked.
export const indicatorStyles = cva(
  [
    "relative flex size-full items-center justify-center",
    "after:content-'' after:absolute after:size-1.5 after:rounded-full after:opacity-0",
    "after:transition-all after:duration-300 after:ease-[cubic-bezier(.78,.14,.15,.86)]",
    "data-disabled:after:bg-neutral-90",
    "data-[state=checked]:after:opacity-100",
  ],
  {
    variants: {
      size: {
        sm: "data-[state=checked]:after:scale-150",
        md: "data-[state=checked]:after:scale-[2]",
      },
      color: {
        primary: "after:bg-primary-50",
        error: "after:bg-error-50",
      },
    },
    // No default size: a group that sets none keeps the unscaled dot it always had.
    defaultVariants: {
      color: "primary",
    },
  }
);

export const labelStyles = cva(
  "font-semibold text-neutral-10 aria-disabled:cursor-not-allowed aria-disabled:text-neutral-80",
  {
    variants: {
      size: {
        sm: "text-sm",
        md: "text-base",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  }
);
